// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___2nmws"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/resultsText/styles.css
// module id = G5OA
// module chunks = 2